// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3JHXa","actionsCol":"EnrolledClinics_actionsCol__1mAU8"};